import { staffCaregiverHiringRoutePrefixes } from "../platform/routes/products/staffCaregiverHiringRoutes";
import { schedulingBookingsRoutePrefixes } from "../platform/routes/products/schedulingBookingsRoutes";
import { walletRoutePrefixes } from "../platform/routes/products/walletRoutes";
import { conversationalBotRoutePrefixes } from "../platform/routes/products/conversationalBotRoutes";

export const PRODUCT_REGISTRY = [
  {
    id: "staffCaregiverHiring",
    label: "Team",
    routePrefixes: staffCaregiverHiringRoutePrefixes,
  },
  {
    id: "schedulingBookings",
    label: "Scheduling & Bookings",
    routePrefixes: schedulingBookingsRoutePrefixes,
  },
  {
    id: "wallet",
    label: "Wallet",
    routePrefixes: walletRoutePrefixes,
  },
  {
    id: "conversationalBot",
    label: "Conversational Bot",
    routePrefixes: conversationalBotRoutePrefixes,
  },
];

export const PRODUCT_IDS = PRODUCT_REGISTRY.map((product) => product.id);
